import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import { navigate } from "gatsby";
import { useGetTree } from "../../../hooks/useGetTree";
import { Category } from "../../../interfaces/Article.interface";
import useChangeTheme from "../../../shared/hooks/useChangeTheme";
import "./TreeCategories.scss";

// @ts-ignore
import iconPlus from "../../../assets/icons/CDA/icon_plus_2.svg";
// @ts-ignore
import iconMinus from "../../../assets/icons/CDA/icon_minus_2.svg";
// @ts-ignore
import iconPlusDark from "../../../assets/icons/CDA/icon_plus_2_dark.svg";
// @ts-ignore
import iconArrow from "../../../assets/icons/CDA/right_arrow.svg";

interface Props {
  hideMobile?: boolean;
}

interface AcordeonProps {
  state: any;
  category: Category;
}

const TreeCategories = ({ hideMobile = false }: Props) => {
  const [isDark] = useChangeTheme();
  const { title, categories, selectedCategory, selectedSubCategory } =
    useGetTree();

  const isActiveCategory = (url: string | undefined) => {
    return url === selectedCategory?.url;
  };

  const isActiveSubcategory = (name: string | undefined) => {
    return name === selectedSubCategory?.name;
  };

  const AccordionHeader = ({ state, category }: AcordeonProps) => {
    return (
      <>
        <div
          className={`a-tree-btn__title gtmMenulatrealcategorias${category.name.replace(
            / /g,
            ""
          )}`}
        >
          <span
            className={`gtmMenulatrealcategorias${category.name.replace(
              / /g,
              ""
            )}`}
          >
            <img
              className="a-tree-btn__icon"
              src={category.image?.[0]?.file.url}
              alt="Category Icon"
            />
          </span>
          <section
            className={`gtmMenulatrealcategorias${category.name.replace(
              / /g,
              ""
            )} ${state.isEnter ? "open-tree" : ""}`}
          >
            {category.name}
          </section>
        </div>
        <div
          className={`a-tree-btn__action ${
            state.isEnter ? "open-tree" : ""
          } gtmMenulatrealcategorias${category.name.replace(/ /g, "")}`}
        >
          {state.isEnter ? (
            <img src={iconMinus} alt="Botón contraer" />
          ) : (
            <img
              src={isDark ? iconPlusDark : iconPlus}
              alt="Botón expandir"
              className={`gtmMenulatrealcategorias${category.name.replace(
                / /g,
                ""
              )}`}
            />
          )}
        </div>
      </>
    );
  };

  return (
    <div className={`m-tree-categories ${hideMobile ? "hide__mobile" : ""}`}>
      <h3 className="m-tree-title">{title}</h3>
      <Accordion transition className="m-tree-container">
        {categories?.map(category => (
          <AccordionItem
            key={category.url}
            header={({ state }) => (
              <AccordionHeader category={category} state={state} />
            )}
            initialEntered={isActiveCategory(category.url)}
            contentProps={{
              className: ({ isEnter }) => (isEnter ? "remove-height" : ""),
            }}
            buttonProps={{
              className: ({ isEnter }) =>
                `a-tree-btn gtmMenulatrealcategorias${category.name.replace(
                  / /g,
                  ""
                )} ${isEnter ? "a-tree-btn--open" : ""}  ${
                  isDark ? "a-tree-btn--dark" : ""
                }`,
            }}
          >
            {({ state }) => (
              <Accordion
                className={`a-tree-body ${state.isEnter ? "open-tree" : ""}`}
                transition
              >
                {category.sections?.map(section => (
                  <button
                    key={section.url}
                    onClick={() => {
                      document.body.classList.remove("noscroll");
                      navigate(section.url);
                    }}
                    className={`a-tree-section ${
                      isActiveSubcategory(section.name) ? "section-active" : ""
                    }`}
                  >
                    {section.name}
                    <img
                      className={isDark ? "dark-arrow" : ""}
                      src={iconArrow}
                      alt="subcategoria"
                    />
                  </button>
                ))}
              </Accordion>
            )}
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default TreeCategories;
